<template>
  <section class="container">
    <div class="shopping-step2">
      <Progress :step.sync="step" />

      <!-- 訂單明細 -->
      <OrderDetail
        :IsReady="IsReady"
        :step.sync="step"
        :ShoppingData.sync="ShoppingData"
        :backTotalPrice.sync="backTotalPrice"
      />

      <div class="shopping-step2__forms">
        <!-- 收件人資料 -->
        <div class="shopping-step2__section shopping-step2__section--recipient">
          <el-form
            style="width: 100%;"
            :model="OrderForm"
            label-position="top"
            :rules="OrderRules"
            ref="OrderForm"
            class="shopping-step2__form form"
            data-style="2"
            @submit.prevent.native
          >
            <h4 class="shopping-step2__title">{{ $t('shopping.section.recipientInfo') }}</h4>
            <div class="shopping-step2__form-body">
              <!-- 姓名 -->
              <div class="form-field">
                <label class="form-label" for="recipientName">
                  {{ $t('shopping.label.recipientName') }}
                </label>
                <el-form-item prop="orderName">
                  <el-input
                    :class="`el-input__input`"
                    :placeholder="$t('shopping.placeholder.recipientName')"
                    type="text"
                    id="recipientName"
                    v-model="OrderForm.orderName"
                  />
                </el-form-item>
              </div>

              <!-- 手機 -->
              <div class="form-field">
                <label class="form-label" for="recipientPhone">
                  {{ $t('shopping.label.recipientPhone') }}
                </label>
                <el-form-item prop="orderPhone">
                  <el-input
                    :class="`el-input__input`"
                    :placeholder="$t('shopping.placeholder.recipientPhone')"
                    type="text"
                    id="recipientPhone"
                    v-model="OrderForm.orderPhone"
                  />
                </el-form-item>
              </div>

              <!-- 收件人住址 -->
              <div class="form-field">
                <label class="form-label" for="recipientAddress">
                  {{ $t('shopping.label.recipientAddress') }}
                </label>

                <div class="form-address">
                  <el-form-item
                    prop="orderZipCode"
                    class="form-address__zipCode"
                  >
                    <el-input
                      :placeholder="$t('common.placeholder.zipCode')"
                      v-model="OrderForm.orderZipCode"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    prop="orderCounty"
                    class="form-address__county"
                  >
                    <el-select
                      :style="`display: block;`"
                      v-model="OrderForm.orderCounty"
                      @change="SetCityList(1, 'order')"
                      :placeholder="$t('common.placeholder.selectCounty')"
                    >
                      <el-option
                        v-for="item in CountyOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    prop="orderCity"
                    class="form-address__city"
                  >
                    <el-select
                      :style="`display: block;`"
                      v-model="OrderForm.orderCity"
                      @change="SetZipCode('order')"
                      :placeholder="$t('common.placeholder.selectCity')"
                    >
                      <el-option
                        v-for="item in orderCityOption"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item prop="orderAddress" class="form-address__address">
                    <el-input
                      :class="`el-input__input`"
                      :placeholder="$t('common.placeholder.address')"
                      type="text"
                      id="recipientAddress"
                      v-model="OrderForm.orderAddress"
                    />
                  </el-form-item>
                </div>
              </div>

              <!-- 寄送注意事項 -->
              <div class="form-field">
                <label class="form-label" for="recipientNote"
                  >{{ $t('shopping.label.shippingNotes') }}</label
                >
                <div>
                  <textarea
                    class="shopping-step2__textarea"
                    id="recipientNote"
                    rows="3"
                    placeholder=""
                    v-model="OrderForm.orderNote"
                  />
                </div>
              </div>
            </div>
            <div class="shopping-step2__divider"></div>
            <h4 class="shopping-step2__title">{{ $t('shopping.section.paymentMethod') }}</h4>
            <p class="shopping-step2__notice">
              {{ $t('shopping.notice.atmNotMobile') }}
            </p>
            <p class="shopping-step2__notice">
              {{ $t('shopping.notice.paymentDeadline') }}
            </p>
            <p class="shopping-step2__notice shopping-step2__notice--last">
              {{ $t('shopping.notice.paymentDays') }}
            </p>
            <el-form-item prop="orderPayMode">
              <div class="shopping-step2__payment-grid">
                <template v-for="item in PayMode">
                  <div
                    class="shopping-step2__payment-item"
                    :key="item.id"
                    v-if="
                      item.id > 0 &&
                        ((item.id !== 2 && item.id !== 5) ||
                          (item.id === 2 && backTotalPrice <= 20000) ||
                          (item.id === 5 && backTotalPrice >= 12000))
                    "
                  >
                    <button
                      type="button"
                      class="shopping-step2__payment-button"
                      :class="{
                        'shopping-step2__payment-button--active':
                          OrderForm.orderPayMode === item.id,
                      }"
                      @click="ChoosePay(item.id)"
                    >
                      {{ translateName(`shopping.label.paymentMethod.${item.id}`, item.name ) }}
                    </button>
                  </div>
                </template>
              </div>
            </el-form-item>
            <p class="shopping-step2__payment-info" v-if="OrderForm.orderPayMode === 5">
              {{ $t('shopping.notice.installmentBanks') }}
              中信、台新、玉山、富邦、遠東、永豐、國泰世華、華南、日盛、樂天、安泰、聯邦、兆豐、台中商銀、
              上海銀行、凱基、匯豐、星展、新光、合庫、彰銀、一銀、元大、陽信、台灣企銀、華泰、三信商銀
            </p>
            <div class="shopping-step2__payment-info" v-if="OrderForm.orderPayMode === 3">
              <p>{{ $t('shopping.label.atmNotice') }}</p>
              {{ $t('shopping.notice.cardReaderRequired') }}<br />
              {{ $t('shopping.notice.windowsOnly') }}
            </div>
            <template v-if="OrderForm.orderPayMode !== 4">
              <div class="shopping-step2__divider"></div>
              <h4 class="shopping-step2__title">{{ $t('shopping.section.invoiceInfo') }}</h4>
              <p class="shopping-step2__notice shopping-step2__notice--last">
              {{ $t('shopping.notice.invoiceNoChange') }}
              </p>
              <el-form-item prop="orderInvoiceType">
                <div class="shopping-step2__payment-grid">
                  <template v-for="item in InvoiceMode">
                    <div
                      class="shopping-step2__payment-item"
                      :key="`InvoiceMode_${item.id}`"
                      v-if="item.id !== 0"
                    >
                      <button
                        type="button"
                        class="shopping-step2__payment-button"
                        :class="{
                          'shopping-step2__payment-button--active':
                            OrderForm.orderInvoiceType === item.id,
                        }"
                        @click="ChooseInvoice(item.id)"
                      >
                        {{ translateName(`shopping.label.invoiceType.${item.id}`, item.name ) }}
                      </button>
                    </div>
                  </template>
                </div>
              </el-form-item>
              <div class="shopping-step2__form-body" v-if="OrderForm.orderInvoiceType !== 0">
                <!-- 手機條碼 -->
                <div class="form-field"  v-if="OrderForm.orderInvoiceType === 2">
                  <label class="form-label" for="memberInvoiceCode">
                    {{ $t('shopping.label.mobileCarrier') }}
                  </label>
                  <el-form-item
                    key="mobileCode"
                    prop="memberInvoiceCode">
                    <label>{{ $t('shopping.instruction.mobileCarrier') }}</label>
                    <el-input
                      :class="`el-input__input`"
                      :placeholder="$t('shopping.placeholder.mobileCarrier')"
                      id="memberInvoiceCode"
                      type="text"
                      v-model="OrderForm.memberInvoiceCode"
                      @focus="memberInvoiceCodeCheckError = false"
                    />
                  </el-form-item>
                </div>
                <!-- 統一編號 -->
                <div class="form-field"  v-if="OrderForm.orderInvoiceType === 3">
                  <label class="form-label" for="memberInvoiceTaxId">
                    {{ $t('shopping.label.taxId') }}
                  </label>
                  <el-form-item
                    key="TaxIdCode"
                    prop="memberInvoiceTaxId">
                    <el-input
                      :class="`el-input__input`"
                      :placeholder="$t('shopping.placeholder.taxId')"
                      type="text"
                      id="memberInvoiceTaxId"
                      v-model="OrderForm.memberInvoiceTaxId"
                      maxlength="8"
                    />
                  </el-form-item>
                </div>
                <!-- 抬頭 -->
                <div class="form-field"  v-if="OrderForm.orderInvoiceType === 3">
                  <label class="form-label" for="memberInvoiceTitle">
                    {{ $t('shopping.label.invoiceTitle') }}
                  </label>
                  <el-form-item
                    key="InvoiceTitle"
                    prop="memberInvoiceTitle">
                    <el-input
                      :class="`el-input__input`"
                      :placeholder="$t('shopping.placeholder.invoiceTitle')"
                      type="text"
                      id="memberInvoiceTitle"
                      v-model="OrderForm.memberInvoiceTitle"
                    />
                  </el-form-item>
                </div>
                <!-- 手機號碼 -->
                <div class="form-field"  v-if="OrderForm.orderInvoiceType === 3">
                  <label class="form-label" for="memberInvoicePhone">
                    {{ $t('common.label.phone') }}
                  </label>
                  <el-form-item
                    key="InvoicePhone"
                    prop="memberInvoicePhone">
                    <el-input
                      :class="`el-input__input`"
                      :placeholder="$t('common.placeholder.phone')"
                      type="text"
                      id="memberInvoicePhone"
                      v-model="OrderForm.memberInvoicePhone"
                    />
                  </el-form-item>
                </div>
                <!-- 信箱 -->
                <div class="form-field"  v-if="OrderForm.orderInvoiceType === 3">
                  <label class="form-label" for="memberInvoiceEmail">
                    {{ $t('common.label.email') }}
                  </label>
                  <el-form-item
                    key="InvoiceEmail"
                    prop="memberInvoiceEmail">
                    <el-input
                      :class="`el-input__input`"
                      :placeholder="$t('common.placeholder.email')"
                      type="text"
                      id="memberInvoiceEmail"
                      v-model="OrderForm.memberInvoiceEmail"
                    />
                  </el-form-item>
                </div>
                <!-- 住址 -->
                <div
                  class="form-field"
                  v-if="OrderForm.orderInvoiceType === 3"
                >
                  <label class="form-label" for="memberInvoiceAddress">
                    {{ $t('common.label.address') }}
                  </label>

                  <div class="form-address">
                    <el-form-item
                      key="InvoiceZipCode"
                      prop="memberInvoiceZipCode"
                      class="form-address__zipCode"
                    >
                      <el-input
                        :placeholder="$t('common.placeholder.zipCode')"
                        v-model="OrderForm.memberInvoiceZipCode"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item
                      key="InvoiceCounty"
                      prop="memberInvoiceCounty"
                      class="form-address__county"
                    >
                      <el-select
                        :style="`display: block;`"
                        v-model="OrderForm.memberInvoiceCounty"
                        @change="SetCityList(1, 'memberInvoice')"
                        :placeholder="$t('common.placeholder.selectCounty')"
                      >
                        <el-option
                          v-for="item in CountyOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      key="InvoiceCity"
                      prop="memberInvoiceCity"
                      class="form-address__city"
                    >
                      <el-select
                        :style="`display: block;`"
                        v-model="OrderForm.memberInvoiceCity"
                        @change="SetZipCode('memberInvoice')"
                        :placeholder="$t('common.placeholder.selectCity')"
                      >
                        <el-option
                          v-for="item in memberInvoiceCityOption"
                          :key="item.label"
                          :label="item.label"
                          :value="item.label"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      key="InvoiceAddress"
                      prop="memberInvoiceAddress"
                      class="form-address__address">
                      <el-input
                        :class="`el-input__input`"
                        :placeholder="$t('common.placeholder.address')"
                        type="text"
                        id="recipientAddress"
                        v-model="OrderForm.memberInvoiceAddress"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </template>
          </el-form>
        </div>

        <!-- 上一步/下一步按鈕 -->
        <div
          class="shopping-step2__actions"
          :class="{ 'shopping-step2__actions--single': orderId !== 0 }"
        >
          <router-link
            v-if="orderId === 0"
            class="shopping-step2__button shopping-step2__button--outline"
            to="/shopping/step1"
          >
            {{ $t('common.button.prevStep') }}
          </router-link>
          <a
            href=""
            class="shopping-step2__button shopping-step2__button--primary"
            @click.prevent="next"
          >
            {{ $t('shopping.button.checkout') }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Progress from '@/components/Shopping/Progress.vue';
import OrderDetail from '@/components/Shopping/OrderDetail.vue';
import { GetCountyList, GetCityList, GetCityByZipCode } from '@/lib/zipcode';

import {
  GetShoppingCart,
  GetOrderPayMode,
  GetOrderInvoiceType,
  SaveShoppingCart,
  GetOrderCart,
  SaveOrderCart,
  CheckEcPayBarcode,
  CheckInvoiceUid,
} from '@/api/ShoppingCartApi';

export default {
  components: {
    Progress,
    OrderDetail,
  },
  data() {
    const checkPayMode = (rule, value, callback) => {
      setTimeout(() => {
        if (this.OrderForm.orderPayMode === 0) {
          callback(new Error(this.$t('validation.paymentMethodRequired')));
        } else {
          callback();
        }
      }, 1);
    };

    const checkInvoiceCode = (rule, value, callback) => {
      const patt = /^\/[0-9A-Z.+-]{7}$/;
      if (this.memberInvoiceCodeCheckError === true) {
        callback(new Error(this.$t('validation.mobileCarrierError')));
      } else if (!patt.test(value)) {
        callback(new Error(this.$t('validation.mobileCarrierError')));
      } else {
        callback();
      }
    };

    const checkInvoiceTaxId = (rule, value, callback) => {
      const calcAry = [1, 2, 1, 2, 1, 2, 4, 1];
      let checkState = true;
      // 組合驗證字串
      let sum = 0;

      // 檢核基本組合
      if (!/^[0-9]{8}$/.test(value)) {
        checkState = false;
      }

      // 計算字元的數值
      for (let i = 0; i < 8; i += 1) {
        const charInt = parseInt(value.charAt(i), 10);

        // 計算總字元數值(每個字元的權重不一樣以 calcAry 來計算)
        const charSum = charInt * calcAry[i];

        sum = sum + (charSum % 10) + ((charSum - (charSum % 10)) / 10);
      }

      // 如第7個數字是 7 總和 +1
      if (value.charAt(6) === '7') {
        sum += 1;
      }

      // 總和除 10 餘數不等於 0 時，返回錯誤
      if (sum % 10 !== 0) {
        checkState = false;
      }

      if (this.memberInvoiceCodeCheckError === true) {
        callback(new Error(this.$t('validation.taxIdError')));
      } else if (checkState === false) {
        callback(new Error(this.$t('validation.taxIdError')));
      } else {
        callback();
      }
    };

    const checkMobileFormat = (rule, value, callback) => {
      const patt = /^09[0-9]{8}$/;
      if (!patt.test(value)) {
        callback(new Error(this.$t('validation.phoneFormat')));
      } else {
        callback();
      }
    };

    return {
      orderId: 0,
      step: 1,
      ShoppingData: {
        orderId: 0,
        shoppings: [
          {
            courseId: 0,
            courseName: '',
            courseOriPrice: 0,
            coursePrice: 0,
            classCount: 0,
            shoppingCartDetails: [
              {
                classId: 0,
                className: '',
                subjectName: '',
                teacherName: '',
              },
            ],
          },
        ],
        discountId: 0,
        discountMode: 0,
        discountName: '',
        discountCode: '',
        discountType: 0,
        discountPrice: 0,
        discountPercent: 0,
        discountMoney: 0,
        orderName: '',
        orderPhone: '',
        orderZipCode: '',
        orderCounty: '',
        orderAddress: '',
        orderNote: '',
        orderPayMode: 0,
        orderPayModeName: '',
      },
      PayMode: {},
      InvoiceMode: {},
      IsReady: false,
      backTotalPrice: 0,
      memberInvoiceCodeCheckError: false,
      memberInvoiceTaxIdCheckError: false,
      OrderForm: {
        orderName: '',
        orderPhone: '',
        orderZipCode: '',
        orderCounty: '',
        orderCity: '',
        orderAddress: '',
        orderNote: '',
        orderPayMode: 0,
        orderPayModeName: '',
        orderInvoiceType: 0,
        orderInvoiceTypeName: '',
        memberInvoiceCode: '', // 行動條碼
        memberInvoiceTitle: '', // "抬頭",
        memberInvoiceAddress: '', // "地址",
        memberInvoiceCity: '', // "鄉鎮",
        memberInvoiceCounty: '', // "城市",
        memberInvoiceZipCode: '', // "郵遞區號",
        memberInvoicePhone: '', // "手機號碼",
        memberInvoiceEmail: '', // "信箱",
        memberInvoiceTaxId: '', // "統一編號",
      },
      OrderRules: {
        // 檢查輸入的值規則
        orderName: [{ required: true, message: this.$t('validation.recipientNameRequired'), trigger: 'blur' }],
        orderPhone: [{ required: true, message: this.$t('validation.recipientPhoneRequired'), trigger: 'blur' }],
        orderCounty: [{ required: true, message: this.$t('validation.countyRequired'), trigger: 'change' }],
        orderCity: [{ required: true, message: this.$t('validation.cityRequired'), trigger: 'change' }],
        orderAddress: [{ required: true, message: this.$t('validation.addressRequired'), trigger: 'blur' }],
        orderPayMode: [{ validator: checkPayMode, trigger: 'blur' }],
        orderInvoiceType: [{ required: true, message: this.$t('validation.invoiceTypeRequired'), trigger: 'blur' }],
        memberInvoiceCode: [
          { required: true, message: this.$t('validation.mobileCarrierRequired'), trigger: 'blur' },
          { validator: checkInvoiceCode, trigger: 'blur' },
        ],
        memberInvoiceTaxId: [
          { required: true, message: this.$t('validation.taxIdRequired'), trigger: 'blur' },
          { validator: checkInvoiceTaxId, trigger: 'blur' },
        ],
        memberInvoiceTitle: [{ required: true, message: this.$t('validation.invoiceTitleRequired'), trigger: 'change' }],
        memberInvoicePhone: [
          { required: true, message: this.$t('validation.phoneRequired'), trigger: 'change' },
          {
            trigger: ['blur', 'change'], min: 10, max: 10, message: this.$t('validation.phoneLength'),
          },
          { trigger: ['blur', 'change'], validator: checkMobileFormat },
        ],
        memberInvoiceEmail: [
          { required: true, message: this.$t('validation.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('validation.emailFormat'), trigger: ['blur', 'change'] },
        ],
        memberInvoiceCounty: [{ required: true, message: this.$t('validation.countyRequired'), trigger: 'change' }],
        memberInvoiceCity: [{ required: true, message: this.$t('validation.cityRequired'), trigger: 'change' }],
        memberInvoiceAddress: [{ required: true, message: this.$t('validation.addressRequired'), trigger: 'blur' }],
      },
      CountyOption: [],
      orderCityOption: [],
      memberInvoiceCityOption: [],
      TmpInvoice: {
        memberInvoiceCode: '', // 行動條碼
        memberInvoiceTitle: '', // "抬頭",
        memberInvoiceAddress: '', // "地址",
        memberInvoiceCity: '', // "鄉鎮",
        memberInvoiceCounty: '', // "城市",
        memberInvoiceZipCode: '', // "郵遞區號",
        memberInvoicePhone: '', // "電話",
        memberInvoiceEmail: '', // "信箱",
        memberInvoiceTaxId: '', // "統一編號",
      },
    };
  },
  async created() {
    const { orderId } = this.$route.params;
    if (orderId !== undefined) this.orderId = orderId;
    await this.GetShoppingCart();

    this.SetCountyList();
    this.SetCityList(0, 'order');
    this.SetCityList(0, 'memberInvoice');

    this.SetZipCode('order');
    this.SetZipCode('memberInvoice');
    await Promise.all([
      this.GetOrderPayMode(),
      this.GetOrderInvoiceType(),
    ]);
  },
  methods: {
    // 如果訊息在 i18n 中存在對應的 key，則使用翻譯，否則返回原始訊息
    translateName(translatedKey, text) {
      const translated = this.$t(translatedKey);
      // 如果翻譯結果與原始 key 不同，表示找到了翻譯
      if (translated !== text) {
        return translated;
      }

      // 返回原始訊息（API 返回的內容）
      return text;
    },

    SetCountyList() {
      this.CountyOption = GetCountyList();
    },
    SetCityList(clear, name) {
      this[`${name}CityOption`] = GetCityList(this.OrderForm[`${name}County`]);
      if (clear === 1) {
        this.OrderForm[`${name}City`] = '';
        this.OrderForm[`${name}ZipCode`] = '';
      } else {
        const data = this[`${name}CityOption`].filter((item) => this.OrderForm[`${name}City`] === item.label);
        if (!data[0]) {
          this.OrderForm[`${name}City`] = '';
          this.OrderForm[`${name}ZipCode`] = '';
        }
      }
    },
    SetZipCode(name) {
      const data = this[`${name}CityOption`].filter((item) => this.OrderForm[`${name}City`] === item.label);
      if (data[0]) {
        this.OrderForm[`${name}ZipCode`] = data[0].value;
      } else {
        this.OrderForm[`${name}ZipCode`] = '';
      }
    },
    ChooseInvoice(id) {
      this.OrderForm.orderInvoiceType = id;
      this.$refs.OrderForm.clearValidate('orderInvoiceType');
    },
    ChoosePay(id) {
      this.OrderForm.orderPayMode = id;
      this.$refs.OrderForm.clearValidate('orderPayMode');

      // 繳費方式不為現場，但發票為紙本發票；就預設為電子發票
      if (id !== 4 && this.OrderForm.orderInvoiceType === 0) {
        this.OrderForm.orderInvoiceType = 1;
      } else if (id === 4 && this.OrderForm.orderInvoiceType !== 0) {
        this.OrderForm.orderInvoiceType = 0;
      }
    },
    GetShoppingCart() {
      let GetWay = GetShoppingCart;
      if (this.orderId !== 0) GetWay = GetOrderCart;
      return GetWay(this.orderId).then((response) => {
        if (response.data.statusCode === 0) {
          this.ShoppingData = response.data.data;
          if (this.ShoppingData.shoppings.length === 0) this.$router.replace('/');
          this._.merge(this.OrderForm, this._.pick(this.ShoppingData, this._.keys(this.OrderForm)));
          if (this.OrderForm.orderCity === null || this.OrderForm.orderCity === '') {
            this.OrderForm.orderCity = GetCityByZipCode(this.OrderForm.orderZipCode);
          }
          this.TmpInvoice = this._.pick(this.ShoppingData, this._.keys(this.TmpInvoice));

          this.ShoppingData.shoppings.forEach((item) => {
            if (item.courseType === 2) {
              item.optionalChooseList.forEach((item2) => {
                // eslint-disable-next-line no-param-reassign
                this.$set(item2, 'teacherChoose', []);
                item2.optionalTeacherList.forEach((item3) => {
                  // eslint-disable-next-line no-param-reassign
                  if (item3.hasTeacher) {
                    item2.teacherChoose.push(item3.teacherId);
                  }
                });
              });
            }
          });
          this.IsReady = true;
        }
      });
    },
    GetOrderInvoiceType() {
      return new Promise((resolve, reject) => {
        GetOrderInvoiceType(0)
          .then((response) => {
            if (response.data.statusCode === 0) {
              this.InvoiceMode = response.data.data;
            }

            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    GetOrderPayMode() {
      return new Promise((resolve, reject) => {
        GetOrderPayMode(0)
          .then((response) => {
            if (response.data.statusCode === 0) {
              this.PayMode = response.data.data;
            }

            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    CheckEcPayBarcode() {
      return new Promise((resolve, reject) => {
        const postData = {
          verificationType: 3,
          verificationData: this.OrderForm.memberInvoiceCode,
        };
        CheckEcPayBarcode(postData)
          .then((response) => {
            this.memberInvoiceCodeCheckError = true;
            if (response.data.statusCode === 0) {
              this.memberInvoiceCodeCheckError = false;
            }
            this.$refs.OrderForm.validateField('memberInvoiceCode');
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    CheckInvoiceUid() {
      return new Promise((resolve, reject) => {
        const postData = {
          Code: this.OrderForm.memberInvoiceTaxId,
        };
        CheckInvoiceUid(postData)
          .then((response) => {
            this.memberInvoiceTaxIdCheckError = true;
            if (response.data.statusCode === 0) {
              this.memberInvoiceTaxIdCheckError = false;
            }
            this.$refs.OrderForm.validateField('memberInvoiceTaxId');
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    async next() {
      this.$refs.OrderForm.validate(async (valid) => {
        if (valid) {
          // 手機條碼才檢查
          if (this.OrderForm.orderInvoiceType === 2) {
            await this.CheckEcPayBarcode();
            if (this.memberInvoiceCodeCheckError === true) {
              return;
            }
          }

          // 統一編號
          if (this.OrderForm.orderInvoiceType === 3) {
            await this.CheckInvoiceUid();
            if (this.memberInvoiceTaxIdCheckError === true) {
              return;
            }
          }

          const PayModeName = this._.find(this.PayMode, { id: this.OrderForm.orderPayMode }).name;
          const InvoiceTypeName = this._.find(this.InvoiceMode,
            {
              id: this.OrderForm.orderInvoiceType,
            }).name;

          this.OrderForm.orderInvoiceTypeName = InvoiceTypeName;
          this.OrderForm.orderPayModeName = PayModeName;

          this._.forEach(this._.keys(this.TmpInvoice), (key) => {
            // 紙本與電子發票不更新原本的資料
            if (this.OrderForm.orderInvoiceType === 0 || this.OrderForm.orderInvoiceType === 1) {
              this.OrderForm[key] = this.TmpInvoice[key];
            } else {
              // 行動條碼的方式，其他參數不異動
              if (this.OrderForm.orderInvoiceType === 2 && key !== 'memberInvoiceCode') {
                this.OrderForm[key] = this.TmpInvoice[key];
              }
              // 其他方式，則是不修改行動條碼
              if (this.OrderForm.orderInvoiceType !== 2 && key === 'memberInvoiceCode') {
                this.OrderForm[key] = this.TmpInvoice[key];
              }
            }
          });

          this._.merge(this.ShoppingData, this.OrderForm);
          let SaveWay = SaveShoppingCart;
          if (this.orderId !== 0) SaveWay = SaveOrderCart;

          SaveWay(this.ShoppingData).then((response) => {
            if (response.data.statusCode === 0) {
              if (this.orderId !== 0) {
                this.$router.push({
                  name: 'Step3',
                  params: { orderId: this.orderId, check: 'check' },
                });
              } else {
                this.$router.push({ name: 'Step3', params: { check: 'check' } });
              }
            }
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.fillAllFields'),
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.shopping-step2 {
  &__forms {
    margin-top: 16px;

    @media (min-width: $breakpoint-md) {
      margin-top: 20px;
    }
  }

  &__section {
    margin-bottom: 16px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 24px;
    }

    &--recipient .shopping-step2__form {
      background-color: #f4f4f4;
    }
  }

  &__form {
    background-color: var(--background-white);
    padding: 24px;
    border-radius: var(--border-radius-base);
    width: 100%;

    @media (max-width: $breakpoint-sm) {
      padding: 20px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 16px;
    }
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: $breakpoint-sm) {
      font-size: 18px;
      margin-bottom: 16px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 16px;
    }
  }

  &__divider {
    height: 1px;
    background-color: var(--border-lighter);
    margin: 32px 0;

    @media (max-width: $breakpoint-sm) {
      margin: 28px 0;
    }

    @media (max-width: $breakpoint-xs) {
      margin: 24px 0;
    }
  }

  &__textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #777;
    border-radius: var(--border-radius-base);
    font-size: 14px;
    color: var(--text-primary);
    background-color: var(--background-white);
    resize: vertical;
    transition: all var(--transition-fast);
    font-family: inherit;
    line-height: 1.5;

    &:focus {
      outline: none;
      border-color: var(--primary-darken-color);
    }

    &:hover {
      border-color: var(--primary-darken-color);
    }

    &::placeholder {
      color: var(--text-placeholder);
    }

    @media (max-width: $breakpoint-sm) {
      font-size: 13px;
    }
  }

  &__notice {
    font-size: 14px;
    color: #f56c6c;
    margin-bottom: 8px;
    line-height: 1.6;

    @media (max-width: $breakpoint-sm) {
      font-size: 13px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 12px;
    }

    &--last {
      margin-bottom: 20px;
    }
  }

  &__payment-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    @media (max-width: $breakpoint-sm) {
      grid-template-columns: 1fr;
    }
  }

  &__payment-item {
    width: 100%;
  }

  &__payment-button {
    width: 100%;
    padding: 10px 16px;
    border: 1px solid var(--primary-color);
    background-color: transparent;
    color: var(--primary-color);
    border-radius: var(--border-radius-base);
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
    text-align: center;

    @media (max-width: $breakpoint-sm) {
      padding: 8px 14px;
      font-size: 14px;
    }

    &:hover {
      background-color: var(--primary-light-color);
      transform: translateY(-1px);
    }

    &--active {
      background-color: var(--primary-color);
      color: #ffffff;

      &:hover {
        background-color: var(--primary-darken-color);
      }
    }
  }

  &__payment-info {
    font-size: 14px;
    color: #f56c6c;
    margin-top: 16px;
    margin-bottom: 0;
    padding: 12px 16px;
    background-color: #fef0f0;
    border-left: 3px solid #f56c6c;
    border-radius: var(--border-radius-base);
    line-height: 1.8;

    @media (max-width: $breakpoint-sm) {
      font-size: 13px;
      padding: 10px 14px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 12px;
    }

    p {
      margin-bottom: 8px;
      font-weight: 500;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 32px;

    &--single {
      justify-content: flex-end;
    }

    @media (max-width: $breakpoint-sm) {
      gap: 12px;
      margin-top: 28px;
    }

    @media (max-width: $breakpoint-xs) {
      flex-direction: column-reverse;
      margin-top: 24px;
    }
  }

  &__button {
    padding: 14px 40px;
    border-radius: var(--border-radius-base);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all var(--transition-fast);
    text-decoration: none;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 160px;

    @media (max-width: $breakpoint-sm) {
      padding: 12px 32px;
      font-size: 15px;
      min-width: 140px;
    }

    @media (max-width: $breakpoint-xs) {
      width: 100%;
      padding: 12px 24px;
      font-size: 14px;
      min-width: auto;
    }

    i {
      font-size: 16px;
    }

    &--outline {
      border: 2px solid var(--primary-darken-color);
      background-color: transparent;
      color: var(--primary-darken-color);

      &:hover {
        transform: translateY(-1px);
      }
    }

    &--primary {
      border: 2px solid var(--primary-darken-color);
      background-color: var(--primary-darken-color);
      color: var(--text-white);

      &:hover {
        transform: translateY(-1px);
      }
    }

    &:active {
      transform: translateY(0);
    }
  }

  /deep/ .el-form-item__content {
    line-height: initial;
  }
}
</style>
